import { useState } from "react";
import Content from "../Content";
import UserTagIcon from "assets/icons/UserTagIcon";
import VLAccordian from "views/components/Accordian";
import ContentBodyLoader from "../Content/ContentBody/ContentBodyLoader";

import styles from "../style.module.scss";
import { FilterItemCountsWithSelect, RightPaneMetrics } from "types";

const USER_TAGS_SECTION_ID = "user-tags-1";

interface UserTagsSectionProps {
  userTagsRef: any;
  sectionHeight: number | false;
  isLoading: boolean;
  userTags: Array<FilterItemCountsWithSelect>;
}

interface UserTagsSectionContentProps {
  isLoading: boolean;
  sectionHeight: number | false;
  selectedMetric: RightPaneMetrics;
  userTags: Array<FilterItemCountsWithSelect>;
}

function NoUserTags() {
  return (
    <div className={styles.noDataWrapper}>
      <div className={styles.noData}>
        Currently no User Tags available in this cluster
      </div>
    </div>
  );
}

const UserTagsSectionContent = ({
  userTags,
  isLoading,
  sectionHeight,
  selectedMetric,
}: UserTagsSectionContentProps) => {
  const initialSelectedID = sectionHeight ? USER_TAGS_SECTION_ID : null;
  const [selectedID, setSelectedID] = useState(initialSelectedID);

  return (
    <div
      className={styles.section}
      style={{ height: !!sectionHeight ? sectionHeight : "max-content" }}
    >
      <Content
        title={"User Tags"}
        totalCount={userTags.length}
        type={"user-tags"}
        data={userTags}
        isLoading={isLoading}
        sectionType={"user-tags"}
        id={USER_TAGS_SECTION_ID}
        selectedID={selectedID}
        selectedMetric={selectedMetric}
        setSelectedID={setSelectedID}
      />
    </div>
  );
};

const UserTagsSection = ({
  userTags,
  userTagsRef,
  sectionHeight,
  isLoading,
}: UserTagsSectionProps) => {
  const [selectedMetric, setSelectedMetric] =
    useState<RightPaneMetrics>("COUNT");

  const onToggleMetrics = () => {
    setSelectedMetric(selectedMetric === "PERCENTAGE" ? "COUNT" : "PERCENTAGE");
  };

  const handleDisplay = () => {
    if (isLoading && !userTags.length) {
      return (
        <div className={styles.loadingBox}>
          <ContentBodyLoader center />
        </div>
      );
    } else if (userTags.length > 0) {
      return (
        <UserTagsSectionContent
          userTags={userTags}
          isLoading={isLoading}
          sectionHeight={sectionHeight}
          selectedMetric={selectedMetric}
        />
      );
    } else return <NoUserTags />;
  };
  return (
    <div className={styles.userTagsWrapper} ref={userTagsRef}>
      <VLAccordian
        key="User Tags"
        initiallyClosed
        title="User Tags"
        icon={<UserTagIcon />}
        id={USER_TAGS_SECTION_ID}
        inSearch={!!sectionHeight}
        selectedMetric={selectedMetric}
        allowResize={userTags.length > 5}
        isLoading={isLoading && !!userTags.length}
        className={styles.metadataSectionAccordian}
        onToggleMetrics={onToggleMetrics}
      >
        {handleDisplay()}
      </VLAccordian>
    </div>
  );
};

export default UserTagsSection;
